import * as defaultImport from "@splunk/react-ui/Paragraph";
export * from "@splunk/react-ui/Paragraph";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
